/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Nav_Group_PrimaryInputs */

const en_layout_nav_group_primary = /** @type {(inputs: Layout_Nav_Group_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main menu`)
};

const pl_layout_nav_group_primary = /** @type {(inputs: Layout_Nav_Group_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu główne`)
};

/**
* | output |
* | --- |
* | "Main menu" |
*
* @param {Layout_Nav_Group_PrimaryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_nav_group_primary = /** @type {((inputs?: Layout_Nav_Group_PrimaryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Nav_Group_PrimaryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_nav_group_primary(inputs)
	return en_layout_nav_group_primary(inputs)
});